import React from 'react';
import ReportViewer from "./base/ReportViewer";

const StatistiquesCaptures = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"StatistiquesCaptures"}/>
        </div>
    );
}
export default StatistiquesCaptures;